"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/**
 * Displays the count of dev tag values that come from multiple flows
 * The values are in the metricsList array.  Each object is in the devtags object.
 *
 * Note: this is required until the issue is resolved in graphql
 *
 */
var _default = exports["default"] = function _default(settings) {
  return function (_ref) {
    var value = _ref.value,
      row = _ref.row;
    var devTagName = settings.devTag;
    var valuesArray = settings.valuesArray;
    var sum = 0;
    row[valuesArray].forEach(function (session) {
      if (!(0, _isNil2["default"])(session.devTags[devTagName])) {
        sum += parseInt(session.devTags[devTagName], 10);
      }
    });
    return /*#__PURE__*/_react["default"].createElement("div", null, sum);
  };
};